import { z } from 'zod';
import type { FilterTemplateToken } from '@sleed/bizcommerce-api';

/**
 * Filter template edit form. Mirrors `FilterTemplateToken` and the legacy admin grid
 * (Core/client/admin/src/pages/Catalog/FilterTemplates/index.js): nm required ≤100, iv boolean,
 * si required, IsDefault boolean, IsManufacturerDefault boolean (template used for manufacturer pages). The filter set is managed in the per-template values sub-grid.
 */
export const filterTemplateSchema = z.object({
	id: z.number().optional(),
	nm: z.string().trim().min(1, 'validation.required').max(100, 'validation.tooLong'),
	iv: z.boolean(),
	si: z.number({ message: 'validation.required' }).int(),
	IsDefault: z.boolean(),
	IsManufacturerDefault: z.boolean()
});

export type FilterTemplateFormValues = z.infer<typeof filterTemplateSchema>;

export const EMPTY_FILTER_TEMPLATE: FilterTemplateFormValues = {
	nm: '',
	iv: true,
	si: 0,
	IsDefault: false,
	IsManufacturerDefault: false
};

export function tokenToForm(token: FilterTemplateToken): FilterTemplateFormValues {
	return {
		id: token.id,
		nm: token.nm ?? '',
		iv: token.iv ?? false,
		si: token.si ?? 0,
		IsDefault: token.IsDefault ?? false,
		IsManufacturerDefault: token.IsManufacturerDefault ?? false
	};
}

export function formToToken(form: FilterTemplateFormValues): FilterTemplateToken {
	return {
		id: form.id,
		nm: form.nm.trim(),
		iv: form.iv,
		si: form.si,
		IsDefault: form.IsDefault,
		IsManufacturerDefault: form.IsManufacturerDefault
	};
}
